import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import AppCompanyIconMenuGroup from '../company/company_icon_menu/AppCompanyIconMenuGroup';

document.addEventListener('DOMContentLoaded', () => {
  Vue.component('InlineSvg', InlineSvg);
  const element = document.getElementById('app-company-icon-menu-group');
  const props = JSON.parse(element.getAttribute('data'));
  new Vue({
    el: '#app-company-icon-menu-group',
    render: (h) => h(AppCompanyIconMenuGroup, { props }),
  });
});
